import { forwardRef, type Ref, type SVGProps } from "react";
const IconHouseHeartFilledSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M27.29 11.4 17.2 1.9a2 2 0 0 0-2.4 0L4.71 11.4A2 2 0 0 0 4 12.93V28a2 2 0 0 0 2 2h20a2 2 0 0 0 2-2V12.93a2 2 0 0 0-.71-1.53m-7 7.6L16 23.3 11.69 19a2.3 2.3 0 0 1-.69-1.66 2.33 2.33 0 0 1 .69-1.66 2.38 2.38 0 0 1 3.33 0l1 1 1-1a2.37 2.37 0 0 1 3.33 0 2.33 2.33 0 0 1 .65 1.66 2.3 2.3 0 0 1-.69 1.66z"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = forwardRef(IconHouseHeartFilledSVG);
ForwardRef.displayName = "IconHouseHeartFilled";
export { ForwardRef as IconHouseHeartFilled };
